import React, {ClipboardEvent, useEffect, useState} from 'react';
import {
    FindEditMode,
    OptionLabelValue,
    PopupSetupType,
    SalesForceContactFormType,
    SelectReactSources,
    SetupRecord,
    SetupRecordWrapper,
    SetupsDataWrapper, SetupsFormControl,
    SetupsFormControlValue,
    SetupsFormControlValueDependency,
    SetupsHiddenControls
} from "../interfaces";
import {sendSetup} from "../DAL/data-service";
import {getIsChina} from "../../../../domain/hidden-data-provider";
import {createControl, validateControl,} from "../../../../domain/validation/validation";
import {getSimpleCaptchaValidationError} from "../../../../domain/captcha/simple-captcha";
import {IFormControl} from "../../../../ui/forms/interfaces";
import {
    getRecaptcha2Error,
    getRecaptchaToken,
    renderRecaptcha2,
    resetRecaptcha2
} from "../../../../domain/captcha/recaptcha-provider";
import Recaptcha3Text from "../../../../domain/captcha/recaptcha3-terms";
import FormTextField from "../../../../ui/forms/fields/text-field";
import {IValidationRules} from "../../../../domain/validation/interfaces";
import {ProcessResult, ProcessResultType} from "../../../../domain/process-result/interfaces";
import FormTextAreaField from "../../../../ui/forms/fields/textarea-field";
import SelectReactField, {IOption} from "../../../../ui/forms/fields/select-react-field";
import {Popup} from "../../../../ui/popup/popup";
import {useAppDispatch, useAppSelector} from "../DAL/store";
import {rootActions} from "../../../account/my-profile/DAL/store";
import {cloneDeep} from "lodash";
import FormCheckboxField from "../../../../ui/forms/fields/checkbox-field";
import ChinaCaptchaField from "../../../../ui/forms/fields/captcha-china-field";
import {getReturnURL} from "../../../../domain/url-provider";
import {isMobile} from "../../../../domain/common";

interface IEventsContactPopUpProps {
    setupsDataWrap: SetupsDataWrapper;
    setupsType: string;
}

/**
 * the entry point
 */
const SalesForceContactPopUp= (props: IEventsContactPopUpProps) => {
    const isChina = getIsChina();
    const dispatch = useAppDispatch();
    const popupSetup =  useAppSelector((store) => store.popupSetup);
    const popupSetupId =  useAppSelector((store) => store.popupSetupId);
    const setupList_Store =  useAppSelector((store) => store.setupList);
    const sfFormDataEX =  useAppSelector((store) => store.sfFormDataEX);
    const setupEdit = sfFormDataEX.setupRecordList.find(f=>f.id === popupSetupId);

    const simpleCaptchaControl = createControl('simpleCaptcha', '', {
        required: true,
        requiredMessage: getSimpleCaptchaValidationError(),
        length: 5,
    });
    const [isLoading, setIsLoading] = useState(false);

    //const [response, setResponse] = useState<IServerValidation|null>();
    const [ResultData, setResultData] = useState<ProcessResult | null>();
    //const [resultMessageShow, setResultMessageShow] = useState(false);

    // simple captcha - used for china
    const [simpleCaptchaCode, setSimpleCaptchaCode] = useState<IFormControl>(simpleCaptchaControl);
    const [simpleCaptchaAttempts, setSimpleCaptchaAttempts] = useState(0);

    // google recaptcha version 2 & 3
    const [recaptchaVersion, setRecaptchaVersion] = useState(3);
    const [recaptcha2WidgetID, setRecaptcha2WidgetID] = useState(0);

    // captcha: common
    const [captchaError, setCaptchaError] = useState('');


    let FormControls = [] as any[];
    const [customControlList, setCustomControlList] = useState<any>();
    const [customControlListSaved, setCustomControlListSaved] = useState<any>();
    const [selectReactSources, setSelectReactSources] = useState<SelectReactSources[]>([]);
    const [IsValidForm, setIsValidForm] = useState<boolean>(true);
    const [hiddenGroups, setHiddenGroups] = useState<number[]>([]);
    //const [hiddenControls] = useState<SetupsHiddenControls[]>([{codeName:'CPU_Intel_M1__c',type:'data-source-empty', class:'invisible',objEx:undefined},{codeName:'Venue__c',type:'on-value-selected', class:'visible',objEx: {controlID:'ctr.drop-single.SoundGrid_Application__c',valueID:66,classOnFind:'visible',classOnNotFind:'hidden'}}]);

    /**
     * load initial data (drop-downs content) on page load once
     */
    useEffect(() => {
        (async () => {
            setIsLoading(false);
            createSetupControlList(props?.setupsDataWrap);


        })();
    }, [props?.setupsDataWrap]);


    /**
     * if recaptcha 3 returns low score (the limit is defined in kentico settings),
     * then recaptcha 2 fallback should be rendered inside <div id="recaptcha"></div>
     */
    const renderCaptcha2Fallback = () => {
        if(!window.grecaptcha) return;

        window.grecaptcha.ready(async () => {
            const widgetID = await renderRecaptcha2('recaptcha-popup');

            setRecaptcha2WidgetID(widgetID);
        });
    };

    /**
     * empty errors on click
     */
    const handleFieldClick = () =>{
        //setResponse(null);
        setCaptchaError('');
    };

    const closeHandler = () => {
        dispatch(
            rootActions.main({
                popupSetup:  PopupSetupType.Hidden
            })
        );
        //console.log('closeHandler');
    }
    const convertAdditionalPropertiesToSend = () => {

        const additionalProperties: { [key: string]: string } = {};
        const _customControlList = cloneDeep(customControlList);
        _customControlList.forEach(function (cl:IFormControl, i:number) {
            const parts = cl.id.split('.');
            if (parts.length === 3) {
                //const prefix = parts[0]; // "ctr"
                const type = parts[1];   // "drop-single"
                const code = parts[2];   // "SoundGrid_Server__c"
                const findControl = props?.setupsDataWrap.setupsFormControl.find(fc=>fc.codeName === code);

                if(findControl) {
                    if(hiddenGroups.includes(findControl.groupID)){
                        additionalProperties[code] = '';
                        return true;
                    }
                }

                if(type === 'textbox' || type === 'textarea'){
                    additionalProperties[code] = cl.value;
                }

                if(type === 'drop-single'){
                    additionalProperties[code] = cl.value.label;
                }

                if(type === 'drop-multi'){
                    const objMulti:any[] = cl.value;
                    var resultString = '';
                    if(Array.isArray(objMulti))
                        resultString = `${objMulti?.map(item => item.label).join(';')}`;
                    else
                        resultString = cl.value.label;

                    //console.log('objMulti:', objMulti);
                    //console.log('resultString:', resultString);
                    additionalProperties[code] = resultString;
                }
                if(type === 'checkbox'){
                    additionalProperties[code] = cl.value;
                }

                if(!additionalProperties[code] || additionalProperties[code] === "{}")
                    additionalProperties[code] = "";

                additionalProperties["name"] = additionalProperties["OS__c"];
                additionalProperties["Account__c"] = "";
            }
        });

        //console.log('additionalProperties: ',additionalProperties);
        return additionalProperties;
    }
    const saveHandler = async () => {

        if(!IsValidFormCheck())
            return;

        const captchaToken = !isChina ? await getRecaptchaToken(recaptchaVersion) : simpleCaptchaCode.value;

        if(!captchaToken){
            setCaptchaError(isChina ? getSimpleCaptchaValidationError() : getRecaptcha2Error());
            setIsLoading(false);
            return;
        }
        //console.log('saveHandler validate true');
        var additionalPropertiesToSend:{ [key: string]: string } = convertAdditionalPropertiesToSend();

        var sendID:string | undefined = '';
        if(popupSetup === PopupSetupType.ShowEdit)
            sendID = setupEdit?.id;

        var sepupsRecordToSend:SetupRecord ={
            name: additionalPropertiesToSend["OS__c"],
            id: sendID ?? '',
            isDeleted: false,
            additionalProperties: additionalPropertiesToSend
        };
        var sepupsRecordWrapperToSend:SetupRecordWrapper ={
            action: (popupSetup === PopupSetupType.ShowAdd || popupSetup === PopupSetupType.ShowClone) ? "create" : "edit",
            setupRecord: sepupsRecordToSend,
            pageType: SalesForceContactFormType.Support,
            captchaCode: captchaToken,
            recaptchaVersion: recaptchaVersion,
        };
        //console.log('sepupsRecordWrapperToSend: ',sepupsRecordWrapperToSend);

        setIsLoading(true);
        const response = await sendSetup(sepupsRecordWrapperToSend);
        //console.log('saveHandler response',response);
        setIsLoading(false);
        if(!response || response.statusCode !== 200) {
            //setError(response.data as unknown as ModelServerErrors);
            return;
        }
        //------------------------------------------------------------------------REDIRECT if not loggined
        if(response.data.resultEXType === "REDIRECT-LOGIN") {
            window.location.href = getReturnURL();
            return;
        }
        //------------------------------------------------------------------------recaptcha-error
        if(isChina){

            // re-render simple captcha
            setSimpleCaptchaAttempts(simpleCaptchaAttempts + 1);
        }
        else{
            if(response?.data.resultEXType === 'recaptcha-error') {
                setRecaptchaVersion(2);
                renderCaptcha2Fallback();
            }

            if(recaptchaVersion === 2){
                resetRecaptcha2();
            }
        }
        //------------------------------------------------------------------------Error message
        if(response.data.message !== '')
            setResultData(response.data);

        //if error => return
        if(response?.data.result !== ProcessResultType.Success)
            return;


        var _sfFormDataEX = cloneDeep(sfFormDataEX);
        var _setupList: OptionLabelValue[] = cloneDeep(setupList_Store);
        if(response?.data.resultEXType === "SETUP-CREATED-SUCCESS") {
            sepupsRecordToSend.id = response?.data.resultEX.id;
            _sfFormDataEX.setupRecordList.push(sepupsRecordToSend);

            let ddlReturned: OptionLabelValue = response?.data.resultEX;
            ddlReturned.id = "new";
            //console.log('response.data: ',response.data);
            //console.log('ddlReturned: ',ddlReturned);

            _setupList.forEach(item => {
                item.id = item.value;
            });
            _setupList.push(ddlReturned);
            //console.log('new _setupList: ',_setupList);
            window.setTimeout(() => {
                dispatch(
                    rootActions.main({
                        setupList:  _setupList,
                        popupSetup:  PopupSetupType.Hidden,
                        sfFormDataEX:_sfFormDataEX
                    })
                );
            }, 500);
        }
        if(response?.data.resultEXType === "SETUP-UPDATED-SUCCESS") {
            _sfFormDataEX.setupRecordList = _sfFormDataEX.setupRecordList?.map(rl =>
                rl.id === sepupsRecordToSend.id ? sepupsRecordToSend : rl
            );
            _setupList.forEach(item => {
                if(item.id === sepupsRecordToSend.id) {
                    item.label = sepupsRecordToSend.name;
                    item.id = 'updated';
                }
            });

            window.setTimeout(() => {
                dispatch(
                    rootActions.main({
                        popupSetup:  PopupSetupType.Hidden,
                        setupList:  _setupList,
                        sfFormDataEX:_sfFormDataEX
                    })
                );
            }, 500);
        }
    }
    const isControlDependency = (controlID:number) => {
        var res = false;
        let controlFind = props?.setupsDataWrap.setupsFormControlValueDependency.filter(f => f.controlID === controlID);

        if(controlFind &&controlFind.length > 0)
            res = true;

        return res;
    }

    const checkHiddenControls = (comp:SetupsFormControl) => {
       var classHideMode = comp.hideMode;
       const find = sfFormDataEX.setupsDataWrap.setupsFormControlHiddenMode.find(f=>f.controlID === comp.controlID);
        if(!find)
            return classHideMode;
        //console.log('checkHiddenControls find: ',comp,find);
        //console.log('customControlList: ',customControlList);
        const findValueSelected:any = customControlList.find((cl:any) =>cl.value.value === find?.selectedID);
        if(!findValueSelected)
            return classHideMode;

        return '';//=> visible
    }
    const getControlDataSource = (controlID:number) => {
        return props?.setupsDataWrap.setupsFormControlValue.filter(f => f.controlID === controlID);

    }
    const selectControlDependency = (controlID:number, selectedID:number) => {
        //console.log('--------------------------------------------------');
        //console.log('selectControlDependency controlID, selectedID: ',controlID,selectedID);
        let dependencyFind = props?.setupsDataWrap.setupsFormControlValueDependency.filter(f => f.selectedID === selectedID);
        let parentChild = props?.setupsDataWrap.setupsFormControlParentChild.filter(f => f.controlIDParent === controlID);
        //let isParent= parentChild && parentChild.length > 0;
        //console.log('dependencyFind: ',dependencyFind);
        //console.log('controlPrarentParentChild: ',parentChild);
        //console.log('isParent: ',isParent);
        const groupedData = groupAndTransform(dependencyFind);
        //console.log('groupedData: ',groupedData);

        var _selectReactSources = cloneDeep(selectReactSources);
        _selectReactSources.forEach(function (rs, i) {
            //console.log('***************');
            //console.log('rs.id: ',rs.id);
            const isChild = parentChild.find(f=>f.controlIDChild === rs.id);
            //console.log('isChild: ',isChild);
            const find = groupedData.find(f=>f.id === rs.id);
            //console.log('find: ',find);
            if(find && find.id > 0){
                rs.dataSource = find.dataSource;
            }
            else if(isChild){
                rs.dataSource = [];
            }
        });
        //console.log('_selectReactSources: ',_selectReactSources);
        setSelectReactSources(_selectReactSources);
    }
    const selectControlDependencyEditMode = (controlID:number, selectedID:number,_selectReactSources:SelectReactSources[]) => {
        //console.log('--------------------------------------------------');
        //console.log('selectControlDependency controlID, selectedID: ',controlID,selectedID);
        let dependencyFind = props?.setupsDataWrap.setupsFormControlValueDependency.filter(f => f.selectedID === selectedID);
        let parentChild = props?.setupsDataWrap.setupsFormControlParentChild.filter(f => f.controlIDParent === controlID);
        //let isParent= parentChild && parentChild.length > 0;
        //console.log('dependencyFind: ',dependencyFind);
        //console.log('controlPrarentParentChild: ',parentChild);
        //console.log('isParent: ',isParent);
        const groupedData = groupAndTransform(dependencyFind);
        //console.log('groupedData: ',groupedData);

        _selectReactSources.forEach(function (rs, i) {
            //console.log('***************');
            //console.log('rs.id: ',rs.id);
            const isChild = parentChild.find(f=>f.controlIDChild === rs.id);
            //console.log('isChild: ',isChild);
            const find = groupedData.find(f=>f.id === rs.id);
            //console.log('find: ',find);
            if(find && find.id > 0){
                rs.dataSource = find.dataSource;
            }
            else if(isChild){
                rs.dataSource = [];
            }
        });
        //console.log('_selectReactSources: ',_selectReactSources);
        //setSelectReactSources(_selectReactSources);
        return _selectReactSources;
    }
    function groupAndTransform(array: SetupsFormControlValueDependency[]): SelectReactSources[] {
        const result: Record<number, SelectReactSources> = {};

        array.forEach(item => {
            const { controlID, valueID, controlValue } = item;
            if (!result[controlID]) {
                result[controlID] = {
                    id: controlID,
                    isDependency: false,
                    dataSource: []
                };
            }
            result[controlID].dataSource.push({
                value: valueID,
                label: controlValue
            });
        });

        return Object.values(result);
    }
    const createSetupControlList = (setupsDataWrap: SetupsDataWrapper)=> {
        var findEditModeArr:FindEditMode[] = [];
        var _selectReactSources:SelectReactSources[] =[] ;
        setupsDataWrap.setupsFormControl.forEach(function(fc, i, arrFC){
            //console.log('------------------------------------------');
            var findForEdit:any = undefined;
            if(popupSetup === PopupSetupType.ShowEdit || popupSetup === PopupSetupType.ShowClone)
                findForEdit = setupEdit?.additionalProperties[fc?.codeName];

            let defVal:any = '';
            if(fc.controlType === 'drop-single' || fc.controlType === 'drop-multi'){

                var _dataSource: SetupsFormControlValue[] | undefined = [];
                _dataSource = getControlDataSource(fc.controlID);
                // if/else from old logic
                /*if(!isControlDependency(fc.controlID)) {
                    _dataSource = getControlDataSource(fc.controlID);
                }
                else{
                    _dataSource = getControlDataSource(fc.controlID);
                }*/

                var _IdataSource: IOption[] = [];
                _dataSource?.forEach(function(ds, i, arrDC) {
                    _IdataSource.push({label: ds.controlValue, value: ds.valueID})
                });

                defVal = [];

                // fill JUST default value if exists.dataSourse for ddl will load later in code
                if((popupSetup === PopupSetupType.ShowEdit || popupSetup === PopupSetupType.ShowClone) && findForEdit !== undefined && findForEdit !== '') {

                    //console.log('_dataSource:',_dataSource);
                    //console.log('findForEdit:',findForEdit);
                    let selectedFind = _dataSource.find(f => f.controlValue === findForEdit);
                    //console.log('_dataSource selectedFind:',selectedFind);
                    if(selectedFind )
                        findEditModeArr.push({controlId: fc?.controlID, selectedId: selectedFind.valueID});

                    //for drop-multi convert str1;str2;str3 to Array<> from multi ddl
                    if (fc.controlType === 'drop-multi' ) {
                        let objArray: Array<{ label: string, value: number }> = [];
                        let objStr:string = findForEdit;
                        objArray = objStr.split(';').map(label => ({ label, value: 0 }));
                        objArray.forEach(item => {
                            const find =props?.setupsDataWrap.setupsFormControlValue.find(f=> f.controlID === fc.controlID && f.controlValue === item.label);
                            if(find)
                                item.value = find.valueID;
                        });
                        defVal = objArray;
                    }
                    else {
                        defVal = {label: findForEdit, value: selectedFind?.valueID};
                    }
                }

                _selectReactSources.push({id: fc.controlID, isDependency: isControlDependency(fc.controlID), dataSource: _IdataSource});
            }

            if(fc.controlType === 'checkbox') {
                //console.log('checkbox: ',findForEdit);
                if(popupSetup === PopupSetupType.ShowEdit || popupSetup === PopupSetupType.ShowClone)
                    defVal = findForEdit.toString().toLowerCase() === 'true';
                else if(fc.codeName === 'is_SoundGrid__c' && props?.setupsType === 'live-apps')
                    defVal = true;
                else
                    defVal = false;

                if(!defVal)
                    setHiddenGroups([1]);
            }

            if(fc.controlType === 'textbox' || fc.controlType === 'textarea') {
                if(popupSetup === PopupSetupType.ShowEdit || popupSetup === PopupSetupType.ShowClone)
                    defVal = findForEdit;
            }


            let rules:IValidationRules =
                {
                    required: fc.isMandatory,
                    /*name: (fc.controlType === 'textbox'),*/
                    /*maxlength:(fc.controlType === 'textbox') ? 255 : 999*/
                };


            if(fc.maxCharLength &&  fc.maxCharLength  > 0) {
                rules.maxlength = fc.maxCharLength;

                rules.maxlengthMessage= `Please enter at most ${fc.maxCharLength} characters.`;
                //console.log('rules.maxlengthMessage',fc.codeName ,rules.maxlengthMessage);
            }


            //console.log('rules: ',rules);
            if(fc.controlType === 'drop-single' && fc.isMandatory) {
                rules = {
                    required: (currentControl) => {
                        //console.log('required: ',currentControl);
                        if(!currentControl) return false;

                        const current = currentControl.value;
                        if(!current) return false;
                        //console.log('current.value: ',currentControl,current,current.value);
                        return current.value !== undefined;
                    }
                }
            }

            let customControl = createControl(`ctr.${fc.controlType}.${fc.codeName}` , defVal, rules);
            FormControls.push(customControl);
        });

        // simulate loda dataSourse for control with parent dependency
        if(popupSetup === PopupSetupType.ShowEdit || popupSetup === PopupSetupType.ShowClone) {
            findEditModeArr.forEach(item => {
                _selectReactSources = selectControlDependencyEditMode(item.controlId, item.selectedId, cloneDeep(_selectReactSources))
            });
        }

        //console.log('_selectReactSources: ',_selectReactSources);

        setSelectReactSources(_selectReactSources);
        setCustomControlList(FormControls);
        setCustomControlListSaved(cloneDeep(FormControls));
    }
    const IsValidControlCheckAndUpdate = (controlToCheck: IFormControl)=> {
        let isValid = true;

        let HTML_element = document.getElementById(controlToCheck.id);
        //console.log('IsValidControlCheckAndUpdate: ',HTML_element);
        if(HTML_element !== null){
            // if the element is not hidden
            let updatedControl = validateControl(controlToCheck) as IFormControl;
            handleChangeEvent(updatedControl);
            if(!updatedControl.isValid){
                isValid = false;
            }
        }

        setIsValidForm(isValid);
        //console.log('IsValidControlCheckAndUpdate: ',customControlList);
        //return isFormValid;
    }
    const IsValidFormCheck = ()=> {
        let isFormValid = true;
        if(!customControlList || customControlList?.length  === 0)
            return isFormValid;

        for(let index = 0; index < customControlList.length; index++){
            let HTML_element = document.getElementById(customControlList[index].id);
            if(HTML_element !== null){
                // if the element is not hidden
                let updatedControl = validateControl(customControlList[index]) as IFormControl;
                //let updatedControl  = updateControl(customControlList[index],customControlList[index].value, true);
                //console.log('updatedControl: ',updatedControl);
                customControlList[index] = updatedControl;
                if(!updatedControl.isValid){
                    isFormValid = false;
                }
            }

        }

        setIsValidForm(isFormValid);
        return isFormValid;
    }
    const handleChangeEvent = (controlUpd: IFormControl) => {
        //console.log(`handleChangeEvent: `,controlUpd);
        let controlList = cloneDeep(customControlList);
        for(let index = 0; index < controlList.length; index++){
            if(controlList[index].id === controlUpd.id){
                controlList[index].value = controlUpd.value;
                controlList[index].isValid = controlUpd.isValid;
                controlList[index].error = controlUpd.error;
            }
        }
        setCustomControlList(controlList);
    };
    const clearForm = () => {
        let controlListSaved = cloneDeep(customControlListSaved);
        setCustomControlList(controlListSaved);
        simpleCaptchaCode.value = '';
        setSimpleCaptchaCode(simpleCaptchaCode);
    };
    return (
        <div id="add-edit-dialod"
             className="my-4"
             role="dialog"
             aria-labelledby="popup-setup-title"
             aria-modal="true"
        >

            {
                <>

                    <Popup classes="waves-box-ml mx-auto px-5 md:px-12 xl:px-0" close={ closeHandler } canBeClosed={false}>
                        <div className="flex flex-col justify-start items-center overflow-auto w-full h-full my-6 text-left">
                            <div id="popup-setup-title" className="mb-6 text-2xl">
                            {
                                popupSetup === PopupSetupType.ShowAdd &&
                                <>Add New Setup</>
                            }
                            {
                                popupSetup === PopupSetupType.ShowEdit &&
                                <>Edit Setup - {setupEdit?.name}</>
                            }
                            {
                                popupSetup === PopupSetupType.ShowClone &&
                                <>Clone Setup - {setupEdit?.name}</>
                            }
                            </div>
                            {/* <p className="mb-2 text-xl">SetupsPopup: {popupSetup} ,id: {popupSetupId}</p>*/}
                            {/*<p className="mb-2">selectReactSources: {selectReactSources?.length}</p>*/}
                            {/*<p className="mb-2">*/}
                            {/*    {*/}
                            {/*        selectReactSources.map((rs, i) => {*/}
                            {/*            return (*/}
                            {/*                <span key={'span-' + rs.id}*/}
                            {/*                      className={rs.isDependency ? 'text-red' : ''}>{rs.id} ({rs.dataSource.length}) |</span>*/}
                            {/*            );*/}
                            {/*        })*/}
                            {/*    }*/}
                            {/*</p>*/}
                            <div className="w-full flex flex-wrap">
                                {
                                    customControlList && customControlList.length > 0 &&
                                    selectReactSources && selectReactSources.length > 0 &&

                                    props?.setupsDataWrap.setupsFormControl.map((comp, f) => {
                                        let control = customControlList.filter((contr: any) => contr.id === `ctr.${comp.controlType}.${comp.codeName}`)[0];
                                        const isHiddenGroup = hiddenGroups.find(f => f === comp.groupID);
                                        const isHiddenGroupClass = isHiddenGroup ? ' hidden' : '';
                                        var hiddenControlsClass = '';
                                        //console.log('isHiddenGroup: ',isHiddenGroup,comp.codeName);
                                        switch (comp.controlType) {
                                            case "textbox":
                                                //console.log('TextInputProperties control: ',control);
                                                return (
                                                    /*<div key={'fc-'+f}>TextBOx</div>*/
                                                    <div key={'txt-' + comp.codeName}
                                                         className={`w-full md:w-1/2 ${isHiddenGroupClass}`}>
                                                        <FormTextField
                                                            id={`ctr.${comp.controlType}.${comp.codeName}`}
                                                            rootClasses={"w-full lg:px-2"}
                                                            label={(comp.isMandatory ? '*' : '') + comp.displayName}
                                                            control={control}
                                                            maxLength={9999}
                                                            onChange={evt => {
                                                                const $target = evt.target as HTMLInputElement;
                                                                //console.log('onChange: ',$target);
                                                                control.value = $target.value;
                                                                //handleChangeEvent(control);
                                                                IsValidControlCheckAndUpdate(control);
                                                            }}
                                                            onBlur={evt => {
                                                                IsValidControlCheckAndUpdate(control);
                                                            }}
                                                            onClick={handleFieldClick}
                                                            onPaste={(evt: ClipboardEvent<HTMLInputElement>) => {
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            case "textarea":
                                                return (
                                                    <div key={'txt-' + comp.codeName}
                                                         className={`w-full mb-4 ${isHiddenGroupClass}`}>
                                                        {
                                                            comp.codeName === 'Network_Topology__c' &&
                                                            <div className="px-3 mb-2 text-gray-500">In the field below, please describe how your SoundGrid network is connected. For example: Macbook Pro, DiGiGrid IOX, STG-1608 and Extreme Server-C are connected to one HP1920-8G switch with 6ft Cat 6 STP cables.</div>
                                                        }
                                                        <FormTextAreaField
                                                            id={`ctr.${comp.controlType}.${comp.codeName}`}
                                                            rootClasses={"w-full lg:px-2"}
                                                            label={(comp.isMandatory ? '*' : '') + comp.displayName}
                                                            control={control}
                                                            maxLength={524288}
                                                            cols={4}
                                                            rows={4}
                                                            focus={false}
                                                            onChange={evt => {
                                                                const $target = evt.target as HTMLInputElement;
                                                                //console.log('TextArea');
                                                                control.value = $target.value;
                                                                //handleChangeEvent(control);
                                                                IsValidControlCheckAndUpdate(control);

                                                            }}
                                                            onClick={handleFieldClick}
                                                            onBlur={evt => {
                                                                IsValidControlCheckAndUpdate(control);
                                                            }}
                                                        /></div>)
                                            case "checkbox":
                                                return (
                                                    <div key={'chk-' + comp.codeName}
                                                         className={`w-full flex justify-center py-2 ${isHiddenGroupClass}`}>
                                                        <FormCheckboxField
                                                            id={`ctr.${comp.controlType}.${comp.codeName}`}
                                                            label={(comp.isMandatory ? '*' : '') + comp.displayName}
                                                            isChecked={control.value}
                                                            onChange={() => {
                                                                const isChecked = !control.value;
                                                                control.value = isChecked;
                                                                handleChangeEvent(control);

                                                                if (isChecked)
                                                                    setHiddenGroups([]);
                                                                else
                                                                    setHiddenGroups([1]);
                                                            }}
                                                            onClick={handleFieldClick}
                                                        /></div>
                                                )
                                            case "html":
                                                return (
                                                    <div key={'html-' + comp.codeName} className={""}
                                                         dangerouslySetInnerHTML={{__html: comp.displayName}}/>
                                                )
                                            case "drop-single":
                                                var dataSourceS = selectReactSources?.filter(f => f.id === comp.controlID)[0].dataSource;

                                                //if value NOT contains in dataSourceS = set DefaultValue
                                                const curentControlVal: any = control.value;
                                                if (!Array.isArray(curentControlVal) && curentControlVal.value !== '') {
                                                    const findValue = dataSourceS?.filter(v => v.label === curentControlVal.label);
                                                    //console.log('findValue: ',findValue);

                                                    if (!findValue || findValue.length === 0)
                                                        control.value = [];
                                                }

                                                //Set None when is_SoundGrid__c checked
                                                if(comp.codeName === 'Host_Application_DAW__c' && Array.isArray(control.value ) && control.value.length === 0){
                                                    const isSoundGrid = customControlList.find((c:any)=>c.id === "ctr.checkbox.is_SoundGrid__c");
                                                    if(isSoundGrid && isSoundGrid.value === true) {
                                                        const findNone = dataSourceS?.find(ds=>ds.label === 'None');
                                                        if(findNone)
                                                            control.value = findNone;
                                                    }
                                                }

                                                if(comp.hideMode!== '') {
                                                    hiddenControlsClass = checkHiddenControls(comp);
                                                }


                                                return (
                                                    <div key={'ddl-' + comp.codeName}
                                                         className={`w-full md:w-1/2 ${isHiddenGroupClass} ${hiddenControlsClass}`}>
                                                        <SelectReactField
                                                            idPrefix={`ctr.${comp.controlType}.${comp.codeName}`}

                                                            rootClasses={hiddenControlsClass === 'invisible' ? 'hidden' : 'w-full lg:px-2'}
                                                            onChange={
                                                                (option) => {
                                                                    control.value = option;
                                                                    handleChangeEvent(control);
                                                                    const optionObj: any = option;
                                                                    selectControlDependency(comp.controlID, optionObj.value);
                                                                    ////setResponse(null); // empty server error
                                                                    //setCaptchaError('');
                                                                }
                                                            }
                                                            onBlur={(option) => {
                                                                IsValidControlCheckAndUpdate(control);
                                                            }}

                                                            label={(comp.isMandatory ? '*' : '') + comp.displayName}
                                                            options={dataSourceS}
                                                            selectIdControl={control}
                                                            placeholder={(comp.codeName === 'Host_Application_DAW__c' || comp.codeName === 'OS__c') ? 'Select a system to display options.' : 'Select...'}
                                                        /></div>)
                                            case "drop-multi":
                                                const dataSourceM = selectReactSources?.filter(f => f.id === comp.controlID)[0].dataSource;
                                                //console.log('comp.codeName,control.value: ',comp.codeName,control.value);
                                                if(comp.hideMode!== '')
                                                    hiddenControlsClass = checkHiddenControls(comp);
                                                return (
                                                    <div key={'ddl-' + comp.codeName}
                                                         className={`drop-multi w-full md:w-1/2 ${isHiddenGroupClass} ${hiddenControlsClass}`}>
                                                        <SelectReactField
                                                            idPrefix={`ctr.${comp.controlType}.${comp.codeName}`}
                                                            rootClasses={hiddenControlsClass === 'invisible' ? 'hidden' : 'w-full lg:px-2'}
                                                            onChange={
                                                                (option) => {
                                                                    control.value = option;
                                                                    handleChangeEvent(control);
                                                                    const optionObj: any = option;
                                                                    //console.log('drop-multi: ', comp.controlID, optionObj);
                                                                    selectControlDependency(comp.controlID, optionObj[0].value);
                                                                    ////setResponse(null); // empty server error
                                                                    //setCaptchaError('');
                                                                }
                                                            }
                                                            onBlur={(option) => {
                                                                IsValidControlCheckAndUpdate(control);
                                                            }}
                                                            label={(comp.isMandatory ? '*' : '') + comp.displayName}
                                                            options={dataSourceM}
                                                            selectIdControl={control}
                                                            isMulti={true}
                                                            placeholder={"Select..."}
                                                        />
                                                    </div>)
                                            default:
                                                return (
                                                    <div key={'fc-' + comp.codeName} className="border border-gray-500">
                                                        <div>codeName:{comp.codeName}</div>
                                                        <div>displayName:{comp.displayName}</div>
                                                        <div>controlType:{comp.controlType}</div>
                                                        <div>controlID:{comp.controlID}</div>
                                                        <div>groupID:{comp.groupID}</div>
                                                    </div>
                                                );
                                        }

                                    })
                                }
                            </div>


                            <div className="section button flex pt-4">
                                {
                                    !isLoading &&
                                    <button
                                        type="button"
                                        className="w-btn w-36 md:w-40"
                                        onClick={saveHandler}>Save
                                    </button>
                                }
                                {
                                    isLoading &&
                                    <button
                                        type="button"
                                        className="w-btn w-36 md:w-40 bg-gray-200"
                                        onClick={saveHandler}>Save
                                    </button>
                                }
                                <button
                                    type="button"
                                    className="w-btn w-36 md:w-40 w-btn-outline-black ml-2"
                                    onClick={closeHandler}>Cancel
                                </button>
                                {/*<button*/}
                                {/*    type="button"*/}
                                {/*    className="w-btn ml-2"*/}
                                {/*    onClick={clearForm}*/}
                                {/*    style={{width: '170px'}}>Clear*/}
                                {/*</button>*/}
                            </div>
                            <div className="section-message">
                                {
                                    captchaError &&
                                    <div className="text-sm text-red my-4 text-center"
                                         data-id={recaptcha2WidgetID}>{captchaError}</div>
                                }
                                {
                                    IsValidForm !== null && !IsValidForm &&
                                    <span></span>
                                }
                                {ResultData?.result === ProcessResultType.Fail && ResultData?.message != null && ResultData?.message.toString() !== "" &&

                                    <div className="my-4 error-box" role="alert"
                                         dangerouslySetInnerHTML={{__html: ResultData?.message?.toString()}}/>

                                }
                                {ResultData?.result === ProcessResultType.Success && ResultData?.message != null && ResultData?.message.toString() !== "" &&

                                    <div className="mt-4 ok-box" role="alert"
                                         dangerouslySetInnerHTML={{__html: ResultData?.message?.toString()}}/>

                                }
                                {
                                    /* ------------- google recaptcha version 2 or 3 ------------- */
                                    !isChina &&
                                    <div id="recaptcha-popup"
                                         className={`mb-4 flex justify-center recaptcha recaptcha-version-${recaptchaVersion}`}/>
                                }

                                {
                                    /* ------------- china simple captcha ------------- */
                                    isChina &&
                                    <ChinaCaptchaField
                                        control={simpleCaptchaCode}
                                        setSimpleCaptchaCode={setSimpleCaptchaCode}
                                        simpleCaptchaAttempts={simpleCaptchaAttempts}
                                    />
                                }

                                {
                                    !isChina && recaptchaVersion === 3 &&
                                    <div className="mt-4 text-center">
                                        <Recaptcha3Text/>
                                    </div>
                                }
                            </div>
                        </div>
                    </Popup>
                </>
            }

        </div>
    )
};

export default SalesForceContactPopUp;